<template>
  <div class="search-results-panel m-0">
    <div class="col-12 px-0">
      <div class="search-result-title" @click="routeToInvoicesAndPOWithFilter(result)">{{ searchCardName }} details</div>
    </div>
    <div class="col-12 px-0 py-1 search-result-desc">
      <span v-for="(item, key) in poSearchResultsMap" :key="key">
        {{item.name}} : <span v-html="result.value[item.value]"></span>
      </span>
    </div>
    <div class="row content-card">
      <div class="col-12">
        <span class="span-tag">{{searchCardName}}s</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "POInvoiceResultCard",
  props: {
    result: Object
  },
  data() {
    return {
      searchCardName:'Purchase order',
      poSearchResultsMap: [
        {
          'name':'Supplier name',
          'value':'supplierName'
        },
        {
          'name':'Purchase order number',
          'value':'poNumber'
        },
        {
          'name':'Status',
          'value':'status'
        }
      ]
    }
  },

  methods: {
    routeToInvoicesAndPOWithFilter(searchResult) {
      //Ignore navigationDuplicated as user intended to search same string and navigate again, else print exception
      /* eslint-disable */
      this.$router.push({ name: 'Filtered POs', params: {key: 'poNumber', value: searchResult.value.poNumber }})
          .catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }})
      this.$emit('onSearchResultClicked')
    },

  }
}
</script>

<style scoped>
.search-result-title {
  color: var(--secondary-color);
  font-family: artifaktElementBold;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}


.search-results-panel {
  background-color: #fff;
  color: #979797;
  font-size: 14px;
  margin-bottom: 10px !important;
  margin-top: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding: 15px !important;
  min-height: 80px;
  border: 1px solid #64788D;
  border-radius: 3px;
}
.search-results-panel a:hover{
  color:#0056b3;
  text-decoration: none;
}
.search-result-desc{
  color:#000;
  font-size: 16px;
}
</style>